import React from 'react';
import { useIntl } from 'umi';
import './index.scss';

export function MetacriticScore({ data, isColumns = true }: any) {
  let { channel_name, comment_score, monitor_source } = data;
  const channelName = channel_name.toLowerCase().trim();
  const { formatMessage } = useIntl();
  const ratingTextMap: any = {
    opencritic: 'Critic Score',
    metacritic: 'Metascore',
  };

  const getRatingClassName = (
    channel: string,
    value: number,
    isUser: boolean,
  ) => {
    const score = Number(value);
    const scoreMap: any = {
      opencritic: [40, 70],
      metacritic: [40, 70],
      'opencritic-user': [4, 7],
      'metacritic-user': [4, 7],
    };

    const key = isUser ? channel + '-user' : channel;

    const [bad, good] = scoreMap[key];

    if (score === -1) {
      return 'dbo-normal';
    } else if (score <= bad) {
      return 'dbo-bad';
    } else if (score > good) {
      return 'dbo-good';
    } else {
      return 'dbo-normal';
    }
  }; 
  
  const item = (monitor_source || []).find(
    (item: any) => item.type === 'user_review',
  );

  const isUser = !!item;

  return (
    <div className={`dbo-feeds-row ${isColumns ? '' : 'to-row-show'}`}>
      <p
        className={`${getRatingClassName(channel_name, comment_score, isUser)}`}
      >
        {comment_score === '-1'
          ? formatMessage({ id: 'Unscored' })
          : comment_score}
      </p>
      <p className="dbo-feeds-row-text">
        {isUser
          ? formatMessage({ id: 'Userscore' })
          : formatMessage({ id: ratingTextMap[channelName] })}
      </p>
    </div>
  );
}
